"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ok = exports.object = exports.defined = void 0;
var errors_1 = require("./errors");
var defined = function (target, message) {
    if (target === undefined) {
        throw new errors_1.AssertionError(message);
    }
};
exports.defined = defined;
var object = function (target, message) {
    if (target !== undefined &&
        (typeof target !== 'object' || Array.isArray(target) || target === null)) {
        throw new errors_1.AssertionError(message);
    }
};
exports.object = object;
var ok = function (target, message) {
    if (!target) {
        throw new errors_1.AssertionError(message);
    }
};
exports.ok = ok;
//# sourceMappingURL=assert.js.map